import format from 'date-fns/format';

export default function(value, formatter) {
  if (value) {
    return format(value, formatter);
  }
  return '';
}
